import { useParams } from "react-router-dom"; 
import PlantationPDFComponent from "../components/PlantationPDFComponent";

const PlantationPDFPage = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <div>
     
        <PlantationPDFComponent  id={id} />
     
    </div>
  );
};

export default PlantationPDFPage;
